/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

interface UpdateClientSecretArgs {
  authReadOnly: boolean;
  ssoEnabled: boolean;
  updateClientSecret: boolean;
  isOIDCAuthenticateDisabled: boolean;
  setupSsoTaskRunning: boolean;
  cancelUpdateClientSecret: () => unknown;
  startUpdateClientSecret: () => unknown;
  updateSsoSetup: () => unknown;
}

export default class UpdateClientSecret extends Component<UpdateClientSecretArgs> {}
